import React, { useState, useEffect, useMemo, useCallback } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../services/supplier_appCommonService";

//Components
import Layout from "../../../Layout/Layout";
// import CreateSupplierMasterModal from "../../../Components/Modal/supplier_app/CreateSupplierMasterModal";
import Constants from "../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  addsupplierID,
  // getVendorPerformance,
  getVendorPerformanceList,
  workflow,
} from "../../../redux/feature/supplier_app/supplierSlice";
// import CommonFillter from "../../../Components/Filter/Supplier/SupplierCommonFillter";
import ShowStatus from "../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { formatDateTime } from "../../../common/Validations";
import { SearchField } from "../../../Components/formElements/SearchField";
import SuccessModal from "../../../Components/Modal/supplier_app/SuccessModal";
import CreateInviteSupplierModal from "../../../Components/Modal/supplier_app/CreateInviteSupplierModal";
import ConfirmSendInvitationModel from "../../../Components/Modal/supplier_app/ConfirmSendInvitationModel";
import ConfirmationLoader from "../../../Components/ConfirmationLoader";
import BroadcastModel from "../../../Components/Modal/supplier_app/BroadcastModel";
import SupplierDeactivateModel from "../../../Components/Modal/supplier_app/SupplierDeactivateModel";
import { exportDataTableToExcel } from "../../customer_app/Customer_V2/Common/exportDataTableToExcel";
// import StatusCountForList from "../../../Components/StatusCountForList";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import CreateVendorMasterModal from "./CreateVendorMasterModal";
// import SupplierConstants from "../../../common/SupplierConstants";
// import { MessageCircle } from "lucide-react";
import ChatBox from "../../../Components/ChatBox/ChatBox";
// import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../Components/Sticky/StickyColumn";


const VendorPerfomanceList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Vendor");
  localStorage.setItem("submenu", "Vendor Performance List");
  let supplierData = useSelector((state) => state?.supplier); // User Details from Store
  let supplierTable = useSelector((state) => state?.supplier.pagination); // User Details from Store
  // let config = useSelector((state) => state?.common?.data?.suppliers); // User Details from Store
  // Format the price above to USD using the locale, style, and currency.
  // let USDollar = new Intl.NumberFormat("en-US", {
  //   style: "currency",
  //   currency: "USD",
  // });

  const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [totalRows, setTotalRows] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalShowStatus, setModalShowStatus] = useState(false);
  // eslint-disable-next-line
  const [sendDataModal, setSendDataModal] = useState("");
  // eslint-disable-next-line
  const [modelTitle, setModelTitle] = useState("");
  const [showLast5Modal, setShowLast5Modal] = useState(false);
  const [selectedSupplierLast5, setSelectedSupplierLast5] = useState([]);
  const [selectedSupplierName, setSelectedSupplierName] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const [getAccountGroup, setAccountGroup] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [isPageLoading, setIsPageLoading] = useState(false); // Loading state
  const [selectedRows, setSelectedRows] = useState([]);
  // eslint-disable-next-line
  const [statusCountData, setStatusCountData] = useState([]);

  /* pop success modal */
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const successModalData = {
    title: "Success",
    successMsg: "",
  };
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
    useState(false);
  const [getShowSendInvitationModal, setShowSendInvitationModal] =
    useState(false);
  const [getShowhideBroadcastModel, setShowhideBroadcastModel] =
    useState(false);
  const [getShowSupplierDeactivateModel, setShowSupplierDeactivateModel] =
    useState(false);

  const onSuccessmodel = () => setShowSuccessModal(true);
  const hideSuccessModal = () => setShowSuccessModal(false);
  const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);
  const hideSendInvitationModal = () => setShowSendInvitationModal(false);
  const hideBroadcastModel = () => setShowhideBroadcastModel(false);
  const hideSupplierDeactivateModel = () =>
    setShowSupplierDeactivateModel(false);
  const handleRowSelect = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };
  const sendInvitation = async () => {
    if (selectedRows.length === 0) {
      // alert("Please select at least one row.")
      successModalData.title = "Error";
      successModalData.successMsg = "Please select at least one row.";
      setsucceModalData(successModalData);
      onSuccessmodel();
      return;
    }
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
      };
      // console.log("obj", obj);
      await ItemService.sendInvitation(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleBroadcast = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
        broadcastRemark: payload?.broadcastRemark,
      };
      // console.log("obj", obj);
      await ItemService.supplierBroadcast(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to Broadcast:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleDeactivateSupplier = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const supplierIds = selectedRows.map((row) => row.userId);
      let obj = {
        supplierIds: supplierIds,
        remark: payload?.remark,
      };
      // console.log("obj", obj);
      await ItemService.supplierDeactivate(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to De-activate:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const inviteSupplier = async (formData) => {
    setIsPageLoading(true); // Start loading
    try {
      await ItemService.inviteSupplier(formData).then((item) => {
        if (item?.status === 200) {
          console.log("item", item);
          successModalData.successMsg = item?.message;
          setShowSuccessModal(true);
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const detailedPage = useCallback((supplierID, workflowActionLogs) => {
    dispatch(addsupplierID(supplierID));
    dispatch(workflow(workflowActionLogs));
    navigate(Constants.VENDOR_DETAILS);
  }, [dispatch, navigate]);
  // const preassement = () => {
  //   navigate(SupplierConstants.VENDOR_PREASSESMENT_FORM);
  // };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on categoryItem  Data
  const categoryItemShowModal = useCallback((itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(categoryItemColInfo);
    setModalTitle("Category Details");
    setItemLevelModalShow(true);
     // eslint-disable-next-line
  }, []);

  const certificateDocumentShowModal = useCallback((itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(certificateDocumentColInfo);
    setModalTitle("Certificate document Details");
    setItemLevelModalShow(true);
     // eslint-disable-next-line
  }, []);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */
  // eslint-disable-next-line
  const createRFQ = () => {
    setModalShow(true);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const exportColumns = useMemo(() => [
    { name: "Supplier ID", selector: (row) => row.userId || "--" },
    { name: "Supplier Name", selector: (row) => row.organisationName || "--" },
    { name: "Status", selector: (row) => row.status || "--" },
    { name: "Contact Person", selector: (row) => row.contactfirstName || "--" },
    { name: "Contact Number", selector: (row) => row.contactNumber || "--" },
    { name: "Contact Email", selector: (row) => row.email || "--" },
    { name: "Initiator", selector: (row) => row.initiator || "--" },
    { name: "Category", selector: (row) => row.vendorCategory?.length || 0 },
    { name: "Certificates", selector: (row) => row.certifications?.length || 0 },
    { name: "Created Date", selector: (row) => formatDateTime(row.createdAt) },
    { name: "Delivery Perf(30)", selector: (row) => { const s = row.performance?.summary; return s ? Math.min(s.overallDeliveryPerformance * 30 / 100, 30).toFixed(2) : "0"; } },
    { name: "Avail./Fulfill. (30)", selector: (row) => { const s = row.performance?.summary; if (!s || !s.totalOrderedQuantity) return "0"; const pct = Math.min((s.totalDeliveredQuantity / s.totalOrderedQuantity) * 100, 100); return (pct * 30 / 100).toFixed(2); } },
    { name: "Quality Perf(40)", selector: (row) => { const s = row.performance?.summary; return s ? Math.min(s.overallQualityPerformance * 40 / 100, 40).toFixed(2) : "0"; } },
    { name: "Overall Per(100)", selector: (row) => Math.min(row.performance?.summary?.overallPerformance || 0, 100).toFixed(2) },
    { name: "Performance Status", selector: (row) => row.performance?.summary?.performanceStatus || "N/A" },
  ], []);

  const handleDownloadExcel = useCallback(() => {
    if (!data || data.length === 0) {
      alert("No data available to export");
      return;
    }
    exportDataTableToExcel(data, exportColumns, "Vendor_Performance_List.xlsx");
  }, [data, exportColumns]);
 // eslint-disable-next-line
  const loadInitialSuuplierData = useCallback(() => {
    setData(supplierData?.data);
  }, [supplierData?.data]);

  const handlePageChange = useCallback((page) => {
    let obj = {
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getVendorPerformanceList(obj));
  }, [dispatch, getNewPerPage]);

  const handlePerRowsChange = useCallback(async (newPerPage, page) => {
    let obj = {
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getVendorPerformanceList(obj));
  }, [dispatch]);

  // Common Search Function on button
  const handleSearchFuncApi = useCallback(async () => {
    let obj = {
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getVendorPerformanceList(obj));
  }, [dispatch, getCommonSearchTxt]);

  const loadTotalStatusCount = async () => {
    let obj = {
      queryName: "getSupplier_StatusChartList",
      chartCategory: "status",
    };
    try {
      await ItemService.generateChartQuery(obj).then((item) => {
        // console.log(">> item.data", item?.data);

        if (item?.status === 200) {
          setStatusCountData(item?.data);
        } else {
          console.error("Failed to Status Count");
        }
      });
    } catch (error) {
      console.log("Failed to Status Count", error);
    }
  };

  useEffect(() => {
    if (supplierData?.data) {
      setData(supplierData.data);
    }
  }, [supplierData?.data]);

  //on page load
  useEffect(() => {
    dispatch(getVendorPerformanceList({ page: 1, per_page: getNewPerPage }));
    getMasterData();

    //load status count
    loadTotalStatusCount();

    // Expose debug function on window for browser console testing
    window._debugVendorPerformance = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("userData"))?.token;
        const res = await fetch(process.env.REACT_APP_API_BASE_URL + "api/getVendorPerformanceDebug", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + token,
          },
          body: JSON.stringify({}),
        });
        const data = await res.json();
        console.log("=== VENDOR PERFORMANCE DEBUG ===");
        console.log("PO vendorCodes in DB:", data?.data?.poVendorCodes);
        console.log("Suppliers in DB:", data?.data?.suppliers);
        console.log("=== END DEBUG ===");
        return data;
      } catch (e) {
        console.error("Debug error:", e);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = useMemo(() => [
    
    // {
    //   name: "Profile",
    //   width: "80px",
    //   cell: (row) => (
    //     <img
    //       src="assets/img/profile-img.png"
    //       alt="Profile"
    //       className="rounded-circle profileImageCss"
    //       style={{ width: "40px" }}
    //     />
    //   ),
    // },
    // {
    //   name: "Type",
    //   id: "supplierType",
    //   selector: (row) => row.supplierType || "--",
    //   sortable: true,
    //   cell: (row) => (
    //     <>
    //       {row.supplierTypeDesc === "Domestic " ? (
    //         <span className="bg-table-status bg-table-info-status">
    //           {/* {row.supplierTypeDesc} */} Domestic Vendor
    //         </span>
    //       ) : row.supplierTypeCode === "S02" ? (
    //         <span className="bg-table-status bg-table-new-status">
    //           {/* {row.supplierTypeDesc} */} Factory Vendor
    //         </span>
    //       ) : row.supplierTypeDesc === "Service" ? (
    //         <span className="bg-table-status bg-table-new-status">
    //           {/* {row.supplierTypeDesc} */} Service Vendor
    //         </span>
    //       ) : (
    //         row.supplierTypeDesc
    //       )}

    //     </>
    //   ),
    //   width: "150px",
    // },

    // {
    //   name: "Type",
    //   id:"supplierType",
    //   selector: (row) => row.supplierType || "--",
    //   sortable: true,
    //   cell: (row) => (
    //     <>
    //       {row.supplierTypeCode === "S01" ? (
    //         <span className="bg-table-status bg-table-info-status">
    //           {row.supplierTypeDesc}
    //         </span>
    //       ) : row.supplierTypeCode === "S02" ? (
    //         <span className="bg-table-status bg-table-new-status">
    //           {row.supplierTypeDesc}
    //         </span>
    //       ) : (
    //         row.supplierTypeDesc
    //       )}
    //     </>
    //   ),
    //   width: "150px",
    // },
    {
      name: "Supplier ID",
      selector: (row) => row.userId || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() =>
            detailedPage(row.userId, row.workflowActionLogs)
          }
        >
          {row.userId || "-"}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "Supplier Name",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row.organisationName}</span>
        </>
      ),
      selector: (row) => row.organisationName,
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Workflow log",
    //   selector: (row) => row.workflowActionLogs,
    //   cell: (row) => (
    //     <div
    //       style={{ width: "100%" }}
    //       className="d-flex justify-content-center iconTable"
    //     >
    //       <img
    //         src="assets/img/newIcons/workflow.png"
    //         alt="attachments"
    //         style={{ width: "35px" }}
    //         className="mt-1"
    //         // onClick={() => showStatusInfo(row.workflowActionLogs)}
    //       />
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "132px",
    // },
    // {
    //   name: "Version",
    //   cell: (row) => (
    //     <>
    //       <span>{row.version || "--"}</span>
    //     </>
    //   ),
    //   selector: (row) => row.version,
    //   sortable: true,
    //   width: "100px",
    // },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "170px",
    },
    // {
    //   name: "SAP Number",
    //   selector: (row) => row.sapAssociateNumber || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "PreAssement Form",
    //   sortable: true,
    //   cell: (row) => (
    //     <button
    //       className="btnInfo"
    //       onClick={() => preassement()}
    //     >
    //       +
    //     </button>
    //   ),
    //   width: "170px",
    // },
    {
      name: "Contact Person",
      cell: (row) => (
        <>
          <span>{row.contactfirstName || "--"}</span>
        </>
      ),
      selector: (row) => row.contactfirstName || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Number",
      cell: (row) => (
        <>
          <span>{row.contactNumber || "--"}</span>
        </>
      ),
      selector: (row) => row.contactNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Email",
      cell: (row) => (
        <>
          <span>{row.email || "--"}</span>
        </>
      ),
      selector: (row) => row.email,
      sortable: true,
      width: "220px",
    },
    {
      name: "Initiator",
      selector: (row) => row.initiator || "--",
      sortable: true,
      width: "100px",
    },
    // {
    //   name: "Supplier 360",
    //   cell: (row) => <button className="btnInfo">{"View"} </button>,

    //   width: "150px",
    // },
    // {
    //   name: "Financial Health",
    //   selector: (row) => row.sap_rfq || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Evaluation Score",
    //   selector: (row) => row.sap_rfq || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "ESG score",
    //   selector: (row) => row.sap_rfq || "--",
    //   sortable: true,
    //   width: "100px",
    // },
    // {
    //   name: "ICV Score %",
    //   selector: (row) => row.totalScore || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Category",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => categoryItemShowModal(row.vendorCategory)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.vendorCategory?.length || 0}{" "}
          </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Certificates ",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => certificateDocumentShowModal(row.certifications)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.certifications?.length > 0
              ? row.certifications?.length
              : "0"}{" "}
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Created Date",
      selector: (row) => formatDateTime(row.createdAt),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Company",
    //   cell: (row) => (
    //     <>
    //       <span> {row.companyCode} </span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Block Reason",
    //   selector: (row) => row.rfqTechFocalPerson,
    //   sortable: true,
    //   width: "130px",
    // },
    {
      name: "Delivery Perf(30)",
      selector: (row) => {
        const score = row.performance?.summary?.overallDeliveryPerformance || 0;
        return Math.min(score, 100);
      },
      sortable: true,
      cell: (row) => {
        const score = Math.min(row.performance?.summary?.overallDeliveryPerformance || 0, 100);
        const scaled = (score * 30 / 100).toFixed(2);
        return (
          <span className={Number(scaled) >= 25 ? "text-success fw-bold" : Number(scaled) >= 15 ? "text-warning fw-bold" : "text-danger fw-bold"}>
            {scaled}
          </span>
        );
      },
      width: "160px",
    },
    {
      name:"Avail./Fulfill. (30)",
      selector: (row) => {
        const summary = row.performance?.summary;
        if (!summary) return 0;
        const raw = summary.totalOrderedQuantity > 0
          ? (summary.totalDeliveredQuantity / summary.totalOrderedQuantity) * 100
          : 0;
        return Math.min(raw, 100);
      },
      sortable: true,
      cell: (row) => {
        const summary = row.performance?.summary;
        const rawPct = summary && summary.totalOrderedQuantity > 0
          ? (summary.totalDeliveredQuantity / summary.totalOrderedQuantity) * 100
          : 0;
        const cappedPct = Math.min(rawPct, 100);
        const scaled = (cappedPct * 30 / 100).toFixed(2);
        return (
          <span className={Number(scaled) >= 25 ? "text-success fw-bold" : Number(scaled) >= 15 ? "text-warning fw-bold" : "text-danger fw-bold"}>
            {scaled}
          </span>
        );
      },
      width: "160px",
    },
    {
      name: "Quality Perf(40)",
      selector: (row) => {
        const score = row.performance?.summary?.overallQualityPerformance || 0;
        return Math.min(score, 100);
      },
      sortable: true,
      cell: (row) => {
        const score = Math.min(row.performance?.summary?.overallQualityPerformance || 0, 100);
        const scaled = (score * 40 / 100).toFixed(2);
        return (
          <span className={Number(scaled) >= 35 ? "text-success fw-bold" : Number(scaled) >= 20 ? "text-warning fw-bold" : "text-danger fw-bold"}>
            {scaled}
          </span>
        );
      },
      width: "160px",
    },
    
    {
      name: "Overall Per(100)",
      selector: (row) => {
        const score = row.performance?.summary?.overallPerformance || 0;
        return Math.min(score, 100);
      },
      sortable: true,
      cell: (row) => {
        const summary = row.performance?.summary;
        const score = Math.min(summary?.overallPerformance || 0, 100);
        const scaled = Number(score).toFixed(2);
        const status = summary?.performanceStatus || "N/A";
        return (
          <div>
            <span className={Number(scaled) >= 90 ? "text-success fw-bold" : Number(scaled) >= 70 ? "text-warning fw-bold" : "text-danger fw-bold"}>
              {scaled}
            </span>
            <br />
            <small className={status === "Excellent" ? "text-success" : status === "Good" ? "text-primary" : status === "Average" ? "text-warning" : "text-danger"}>
              {status}
            </small>
          </div>
        );
      },
      width: "160px",
    },

    {
      name: "Last 5 POs Perf",
      cell: (row) => {
        const last5 = row.performance?.last5POs || [];
        return (
          <button className="btnTable" onClick={() => {
            setSelectedSupplierLast5(last5);
            setSelectedSupplierName(row.firstName || row.userId || "");
            setShowLast5Modal(true);
          }}>
            <i className="bi bi-eye"></i> View ({last5.length})
          </button>
        );
      },
      width: "150px",
    },

    {
      name: "SAP Reprocess",
      cell: (row) => (
        <>
          <button className="btnTable">Reprocess {row.publish}</button>
        </>
      ),
      width: "140px",
    },
    // {
    //   name: "Send Invite",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">Invite {row.publish}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
    // {
    //   name: "Re-Invite",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">Re-Invite {row.publish}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
    // {
    //   name: "Edit Supplier",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">Edit {row.publish}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
    // {
    //   name: "Deactivate",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">Deactivate {row.publish}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
     // eslint-disable-next-line
  ], []);

  const categoryItemColInfo = useMemo(() => [
    {
      name: "Category Code",
      cell: (row) => <span>{row.categoryCode} </span>,
      width: "180px",
    },
    {
      name: "Sub Category Code",
      cell: (row) => <span>{row.subCategoryCode} </span>,
      width: "180px",
    },
    {
      name: "Vendor Category",
      cell: (row) => <span>{row.vendorCategoryText} </span>,
      width: "180px",
    },
    {
      name: "Vendor Sub Category",
      cell: (row) => <span>{row.vendorSubCategoryLongText} </span>,
      width: "180px",
    },
  ], []);

  const certificateDocumentColInfo = useMemo(() => [
    {
      name: "Certificate Type",
      cell: (row) => <span>{row.documentType} </span>,
      width: "180px",
    },
    {
      name: "Certificate Number",
      cell: (row) => <span>{row.documentNumber} </span>,
      width: "180px",
    },
    {
      name: "Expiry Date",
      cell: (row) => <span>{row.expirationDate} </span>,
      width: "180px",
    },
    {
      name: "Issueing Authority/Accreditation",
      cell: (row) => <span>{row.issuingAuthority} </span>,
      width: "180px",
    },

    {
      name: "Certificate Attachement",
      cell: (row) => <span>{row.certificateAttachement} </span>,
      width: "180px",
    },
  ], []);

  const getMasterData = async () => {
    let obj = {
      codeType: "accountGroup",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setAccountGroup(item?.data);
      } else {
        setAccountGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  /* Modal Function */
  // const showStatusInfo = (rowData) => {
  //   setModalShowStatus(true);
  //   setSendDataModal(rowData);
  //   setModelTitle("Status Information");
  // };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };
  const [chatId, setChatId] = useState(null);
  // const toggleChat = (groupId) => {
  //   // Toggle the same PR closes the chat
  //   if (chatId === groupId) {
  //     setChatId(null);
  //   } else {
  //     setChatId(groupId);
  //   }
  // };

  return (
    <main className="dashboard main" id="main">
      {/* Spinner Overlay */}
      <ConfirmationLoader isPageLoading={isPageLoading} />
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Vendor Performance List</h2>
                <p className="subText">Vendor Directory and Overview </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />

            {/* Page level indiviual status count data */}
            {/* {statusCountData.length > 0 && (
              <StatusCountForList statuscountdata={statusCountData} />
            )} */}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">VL</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Vendor Performance List</span>
                      <span className="subHeaderTitle">
                        View of Vendor Performance and Status{" "}
                      </span>
                    </Col>
                  

                      <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                        <Col
                      xs={3}
                      md={3}
                      lg={3}
                      className=""
                    >
                      <button
                        className="btnTable btnTable"
                        onClick={handleDownloadExcel}
                        title="Download Excel"
                      >
                        <i className="bi bi-file-earmark-excel"></i> XL Download
                      </button>
                    </Col>
                    </Col>
 
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[3,4,5]}
                        leftOffsets={[0, 60,200]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={supplierData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={supplierTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateVendorMasterModal
        show={modalShow}
        onHide={() => hideModal()}
        dropdownData={getAccountGroup}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
      />
      <CreateInviteSupplierModal
        show={getShowSupplierInviteModal}
        onHide={hideSupplierInviteModal}
        onSubmit={inviteSupplier}
      />
      <ConfirmSendInvitationModel
        show={getShowSendInvitationModal}
        onHide={hideSendInvitationModal}
        onSubmit={sendInvitation}
        selectedRows={selectedRows}
      />
      <BroadcastModel
        show={getShowhideBroadcastModel}
        onHide={hideBroadcastModel}
        onSubmit={handleBroadcast}
        selectedRows={selectedRows}
      />
      <SupplierDeactivateModel
        show={getShowSupplierDeactivateModel}
        onHide={hideSupplierDeactivateModel}
        onSubmit={handleDeactivateSupplier}
        selectedRows={selectedRows}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}

      {/* Last 5 PO Performance Modal */}
      {showLast5Modal && (
        <div className="modal show" style={{ display: "block" }} tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content" style={{ borderRadius: "12px", overflow: "hidden" }}>
              <div className="modal-header">
                <h5 className="modal-title fw-bold">
                  <i className="bi bi-bar-chart-line-fill me-2" style={{ color: "#1565c0" }}></i>
                  Last 5 PO Performance — {selectedSupplierName}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowLast5Modal(false)}></button>
              </div>
              <div className="modal-body" style={{ padding: "20px" }}>
                {selectedSupplierLast5.length === 0 ? (
                  <p className="text-muted text-center py-4">No PO data available</p>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-hover" style={{ fontSize: "13px", marginBottom: 0 }}>
                      <thead>
                        <tr style={{ background: "#f0f4ff" }}>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", whiteSpace: "nowrap" }}>PO Number</th>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", whiteSpace: "nowrap" }}>PO Date</th>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", textAlign: "center" }}>Ordered</th>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", textAlign: "center" }}>Delivered</th>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", textAlign: "center" }}>Remaining</th>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", textAlign: "center" }}>Status</th>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", textAlign: "center", whiteSpace: "nowrap" }}>Delivery (30)</th>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", textAlign: "center", whiteSpace: "nowrap" }}>Availability (30)</th>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", textAlign: "center" }}>Accepted</th>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", textAlign: "center" }}>Rejected</th>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", textAlign: "center", whiteSpace: "nowrap" }}>Quality (40)</th>
                          <th style={{ padding: "10px 12px", borderBottom: "2px solid #dee2e6", textAlign: "center", whiteSpace: "nowrap" }}>Overall (100)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedSupplierLast5.map((po, idx) => {
                          const dScore = po.deliveryPerformance || 0;
                          const aScore = po.availabilityPerformance || 0;
                          const qScore = po.qualityPerformance || 0;
                          const oScore = po.overallPOPerformance || 0;
                          return (
                            <tr key={idx} style={{ borderBottom: "1px solid #f0f0f0" }}>
                              <td className="fw-bold" style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>{po.poNumber}</td>
                              <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>{po.poDate || "-"}</td>
                              <td style={{ padding: "10px 12px", textAlign: "center" }}>{po.orderedQuantity}</td>
                              <td style={{ padding: "10px 12px", textAlign: "center" }}>{po.deliveredQuantity}</td>
                              <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                {po.remainingQuantity > 0 ? (
                                  <span className="text-danger fw-bold">{po.remainingQuantity}</span>
                                ) : (
                                  <span className="text-success fw-bold">0</span>
                                )}
                              </td>
                              <td style={{ padding: "10px 12px", textAlign: "center" }}>
                                <span className={`badge ${po.deliveryStatus === "Completed" ? "bg-success" : po.deliveryStatus === "Partial" ? "bg-warning text-dark" : "bg-secondary"}`} style={{ fontSize: "11px", padding: "4px 10px" }}>
                                  {po.deliveryStatus}
                                </span>
                              </td>
                              <td style={{ padding: "10px 12px", textAlign: "center", whiteSpace: "nowrap" }}>
                                <span className={`fw-bold ${dScore >= 90 ? "text-success" : dScore >= 70 ? "text-warning" : "text-danger"}`}>
                                  {Math.min(dScore * 30 / 100, 30).toFixed(2)}
                                </span>
                              </td>
                              <td style={{ padding: "10px 12px", textAlign: "center", whiteSpace: "nowrap" }}>
                                <span className={`fw-bold ${aScore >= 90 ? "text-success" : aScore >= 70 ? "text-warning" : "text-danger"}`}>
                                  {Math.min(aScore * 30 / 100, 30).toFixed(2)}
                                </span>
                              </td>
                              <td style={{ padding: "10px 12px", textAlign: "center" }}>{po.acceptedQuantity}</td>
                              <td style={{ padding: "10px 12px", textAlign: "center" }}>{po.rejectedQuantity}</td>
                              <td style={{ padding: "10px 12px", textAlign: "center", whiteSpace: "nowrap" }}>
                                <span className={`fw-bold ${qScore >= 90 ? "text-success" : qScore >= 70 ? "text-warning" : "text-danger"}`}>
                                  {Math.min(qScore * 40 / 100, 40).toFixed(2)}
                                </span>
                              </td>
                              <td style={{ padding: "10px 12px", textAlign: "center", whiteSpace: "nowrap" }}>
                                <span className={`fw-bold ${oScore >= 90 ? "text-success" : oScore >= 70 ? "text-warning" : "text-danger"}`}>
                                  {Math.min(Number(oScore), 100).toFixed(2)}
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowLast5Modal(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showLast5Modal && <div className="modal-backdrop show"></div>}
    </main>
  );
};

export default VendorPerfomanceList;
